export default function FormButton({children, ...props}){

    return(
        <>
            <button {...props}>{children}</button>
        </>
    )
}